import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import type {useFetchPricingGroupsQuery} from '../../use-fetch-pricing-groups-query';
import {populateRedux} from './pricing-groups-actions';

export class PricingGroupsState extends Record<{
    readonly pricingGroupsData?: ReturnType<typeof useFetchPricingGroupsQuery>['data'];
}>({
    pricingGroupsData: undefined,
}) {}

export default makeReducer<PricingGroupsState>(
    [
        match(populateRedux, (state, {payload}) => {
            return state.merge({
                pricingGroupsData: payload.data,
            });
        }),
    ],
    new PricingGroupsState(),
);
